import { useLocation } from "wouter";
import { LogoMark } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import QuoteCarousel from "@/components/QuoteCarousel";

export default function NotFound() {
  const [, navigate] = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <LogoMark size={48} />
        </div>
        <div>
          <p className="text-7xl font-bold text-muted-foreground/30 leading-none mb-2">404</p>
          <h1 className="text-2xl font-bold text-foreground">Page not found</h1>
          <p className="mt-2 text-muted-foreground text-sm leading-relaxed">
            The page you're looking for doesn't exist or may have moved.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
          <Button variant="outline" onClick={() => navigate("/")}>
            Back to Home
          </Button>
        </div>
      </div>
      <QuoteCarousel />
    </div>
  );
}
